import { photoWidth } from "./photos"

const SHOP = "https://highclub.store"

/**
 * Where to SHOW a stored photo address: HQ uploads at their 480 width; the seeded products' photos
 * point at a retired host, and the shop serves them itself under /media/.
 */
export function displayUrl(url: string): string {
  if (/-w1600\.(jpg|webp)$/.test(url)) return photoWidth(url, 480)
  try {
    const { pathname } = new URL(url)
    if (pathname.startsWith("/media/")) return `${SHOP}${pathname}`
  } catch {
    // Not an absolute address: shown as it is.
  }
  return url
}
